
import state from './newContactsState.js'
import * as mutations from './newContactsMutations.js'
import * as actions from './newContactsActions.js'
import * as getters from './newContactsGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}